var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "draggable",
          rawName: "v-draggable",
          value: _vm.draggableValue,
          expression: "draggableValue"
        }
      ],
      ref: "imweb",
      class: _vm.$style.imWeb
    },
    [
      _c(
        "div",
        { class: _vm.$style.animateBox, on: { click: _vm.handleToggleShow } },
        [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.animatedScene === 1,
                expression: "animatedScene === 1"
              }
            ],
            attrs: {
              src:
                "https://te--fileservers.oss-cn-hangzhou.aliyuncs.com/web/im-animated/animated-enter.gif",
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.animatedScene === 2,
                expression: "animatedScene === 2"
              }
            ],
            attrs: {
              src:
                "https://te--fileservers.oss-cn-hangzhou.aliyuncs.com/web/im-animated/animated-message.gif",
              alt: ""
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showIm,
              expression: "showIm"
            }
          ],
          class: _vm.$style.iframeContainer
        },
        [
          _c("iframe", {
            ref: "receiver",
            attrs: {
              src: _vm.iframeSrc,
              frameborder: "0",
              scrolling: "no",
              width: "100%",
              height: "100%"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }